import React from 'react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">
          Grand Marabout Bruxelles
        </h1>
        <p className="hero-subtitle">
          Voyant Medium Guérisseur Africain à Bruxelles
        </p>
        <p className="hero-subtitle">
          Résultats Rapides et Garantis - Différent des Autres
        </p>
        
        <div className="hero-contact">
          <p className="hero-phone-label">Contactez Maître Dia</p>
          <div className="contact-buttons-row">
            <a href="tel:+32465619411" className="hero-phone">
              <span>📞</span>
              <span>04 65 61 94 11</span>
            </a>
            <a 
              href="https://wa.me/32465619411" 
              target="_blank" 
              rel="noopener noreferrer"
              className="whatsapp-link"
            >
              <span>💬</span>
              <span>WhatsApp</span>
            </a>
          </div>
        </div>

        <div className="hero-image-container">
          <img 
            src="https://customer-assets.emergentagent.com/job_b0edc02b-5ff0-40c4-a2c1-a0d9aa5fa3a0/artifacts/42hh1h3b_IMG_1408.jpeg" 
            alt="Grand Marabout Africain à Bruxelles"
            className="hero-image"
          />
        </div>

        <div className="hero-cta">
          <Link to="/contact">
            <Button size="lg" className="cta-button">
              EN SAVOIR +
            </Button>
          </Link>
        </div>

        <div className="hero-availability">
          <div className="availability-icon">✨</div>
          <p>
            Consultations disponibles 7 jours sur 7 et 24 heures sur 24<br />
            par téléphone, WhatsApp ou à domicile dans toute la région de Bruxelles
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
